function debounce(fn, delay = 300) {
	var timeoutID = null;

    return function () {
		clearTimeout(timeoutID);

        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
        	fn.apply(that, args);
        }, delay);
    }
};

export default function initSearch() {
    
    new Vue({
        el: "#search_form",
        data: {
            keywords: null,
            results: [],
            loading: false,
            init: true,
            lang: ''
        },
        mounted() {
            this.lang = document.documentElement.lang;
        },
        watch: {
            keywords(after, before) {
                this.fetch();
            }
        },
        directives: {
            debounce: {
                inserted: function (el, binding) {
                    if (binding.value !== binding.oldValue) {
                        el.oninput = debounce(ev => {
                            el.dispatchEvent(new Event('change'));
                        }, parseInt(binding.value) || 300);
                    }
                }
            }
        },
        methods: {
            fetch() {
                if(this.keywords.length < 3) {
                    this.results = [];
                    return;
                };
                this.init = false
                this.loading = true;
                axios.post('/search', {'keyword':this.keywords, 'lang': this.lang})
                .then( response => {
                    this.loading = false;
                    this.results = response.data;
                })  
                .catch( e => { 
                    console.log(e.response);
                    this.loading = false;
                });
            },
        }
    });

}